<template>
  <IModal text-cancel="買い物を続ける" text-ok="カートに進む" :with-action-button="true" :class="$style.modal" @cancel="onCancel" @ok="onOk" @close="onClose">
    <p :class="$style.text">{{ text }}</p>
  </IModal>
</template>

<script setup lang="ts">
import IModal from '@/js/components/molecules/IModal.vue';

withDefaults(
  defineProps<{
    text?: string;
  }>(),
  {
    text: 'カートに追加されました',
  },
);

const emit = defineEmits<{
  (e: 'close'): void;
}>();
const onOk = () => {
  window.location.href = '/cart';
};
const onCancel = () => {
  emit('close');
};
const onClose = () => {
  emit('close');
};
</script>

<style module lang="scss">
.modal button {
  @media (--sp) {
    font-size: 14px;
    height: 46px;
    padding: 12px;
  }
}

.text {
  font-size: 18px;
  font-weight: bold;
}
</style>
